module.exports = __webpack_public_path__ + "static/img/victim-kids-6.ec9264b5.png";